exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgCode[data-v-9d8b8850] {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-color: #ccc;\n  border-radius: 10px;\n}\n.box-card[data-v-9d8b8850] {\n  width: 100%;\n  height: 100%;\n}\n.code[data-v-9d8b8850] {\n  width: 250px;\n  background-color: #fff;\n  position: absolute;\n  top: 35%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.code .wx_code[data-v-9d8b8850] {\n    width: 250px;\n    height: 250px;\n}\n.code .code_text[data-v-9d8b8850] {\n    padding: 0 20px;\n    line-height: 22px;\n    text-align: center;\n}\n", ""]);

// exports
